export const flattenTree = (dataList: Array<any>): Array<any> => {
  return dataList.reduce((conn, data) => {
    conn.push(data)
    if (data.children && data.children.length) {
      conn.push(...flattenTree(data.children))
    }
    return conn
  }, [])
}
